module.exports = __webpack_public_path__ + "static/media/02-2-mobile.bcbc3ce5.webp";